import React from 'react';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import Icon from 'modules/react/components/stateless/Icon';
import style from './TableRow.scss';

const propTypes = {
  rowAuthMsg: PropTypes.string.isRequired,
};

const DisabledIcon = ({ rowAuthMsg }) => {
  const disabledPopover = (
    <Popover id="disabled-row" className="tableTooltip">
      <Icon id="circle-lock" label="disabled-row" />
      <span className={style.tooltipMsg}>
        {rowAuthMsg}
      </span>
    </Popover>
  );

  return (
    <td key="td-cb" className={style.lockIcon}>
      <OverlayTrigger
        placement="right"
        overlay={disabledPopover}
        trigger={['hover', 'focus']}
      >
        <span>
          <Icon id="circle-lock" label="disabled checkbox" />
        </span>
      </OverlayTrigger>
    </td>
  );
};

DisabledIcon.propTypes = propTypes;

export default DisabledIcon;
